import { ExecuteEndpoint } from '../../components/common/BaseApiService';
import { AssignmentRuleResponse } from '../../Model/responseDtos/AssignmentRuleResponse';

export class AssignmentsService {
  public async getAssignmentRules(): Promise<AssignmentRuleResponse[]> {
    return ExecuteEndpoint('assignments/rules', 'GET');
  }
}
